import get from 'lodash/get';
import { REDUCER_KEY_AI_SEARCH_SUMMARY } from './constants';

export const getSummaryState = (state) => state.get(REDUCER_KEY_AI_SEARCH_SUMMARY);
export const getSummaryStatus = (state) => get(getSummaryState(state), 'summaryStatus');
export const getSummaryResponse = (state) => get(getSummaryState(state), 'summaryResponse');
export const getSummaryError = (state) => get(getSummaryState(state), 'summaryError');
